import React from "react";
import { useState } from "react";
import { Popover, Box } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {
  ArrowRight,
  ArrowUpRight,
  Info,
  X,
  Gift,
  Search,
  Calendar,
  Check,
  Pause,
  Trash2,
  ChevronLeft,
  ChevronRight,
  Moon,
  Users,
  Sun,
  Truck,
} from "lucide-react";
import {
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Area,
  ComposedChart,
} from "recharts";
import { FiMoreVertical, FiChevronDown } from "react-icons/fi";
import "react-circular-progressbar/dist/styles.css";
import TotalVouchersIcon from "../../../assets/svg/Group 163015.svg";
import ActiveIcon from "../../../assets/svg/Vector (1).svg";
import ScheduledIcon from "../../../assets/svg/calendar 1.svg";
import DraftIcon from "../../../assets/svg/draft 1.svg";
import UnderReviewIcon from "../../../assets/svg/clock (3) 1.svg";
import PausedIcon from "../../../assets/svg/pause-circle-svgrepo-com 1.svg";
import ExpiredIcon from "../../../assets/svg/support 1.svg";
import DisabledIcon from "../../../assets/svg/Cancel.svg";
import newYear from "../../../assets/svg/party 1.svg";
import welcome from "../../../assets/svg/new-year-balloons 1.svg";
import special from "../../../assets/svg/gift-svgrepo-com 1.svg";
import blackFriday from "../../../assets/svg/black-friday 1.svg";
import OsamaAvatar from "../../../assets/images/alert2 1.png";
import AhmedAvatar from "../../../assets/images/alert2 1 (1).png";
import MonaAvatar from "../../../assets/images/alert2 1 (2).png";
import WELCOME2026 from "../../../assets/svg/new-year-balloons 1 (1).svg";
import SUMMER25 from "../../../assets/svg/sun-2-svgrepo-com 1.svg";
import FALSH50 from "../../../assets/svg/zap-svgrepo-com 1.svg";
import VIP30 from "../../../assets/svg/crown-star-svgrepo-com 2.svg";
import Abuse1 from "../../../assets/svg/Alert triangle.svg";
import Abuse2 from "../../../assets/svg/State Icons 3 (4).svg";
import Abuse3 from "../../../assets/svg/Smartphone.svg";
import Abuse4 from "../../../assets/svg/clock-circle-svgrepo-com 1.svg";
import { useNavigate } from "react-router";

export default function PromoCodes() {

  const navigate = useNavigate();
  
  // date input
  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [startDate, setStartDate] = useState(dayjs("2025-05-01"));
  const [endDate, setEndDate] = useState(dayjs("2025-05-31"));

  const isDatePickerOpen = Boolean(dateAnchorEl);

  const handleDateClick = (e) => setDateAnchorEl(e.currentTarget);
  const handleDateClose = () => setDateAnchorEl(null);

  const dateRangeLabel = `${startDate.format("MMM DD, YYYY")} - ${endDate.format(
    "MMM DD, YYYY",
  )}`;

  // stats
  const stats = [
    {
      title: "Total Promo Codes",
      value: "256",
      icon: TotalVouchersIcon,
      bg: "#000000",
      iconColor: "#FFFFFF",
      trend: "+18%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Active",
      value: "148",
      icon: ActiveIcon,
      bg: "#3FBEAC",
      iconColor: "#14B8A6",
      trend: "+8%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Scheduled",
      value: "28",
      icon: ScheduledIcon,
      bg: "#7E1BAD",
      iconColor: "#A855F7",
      trend: "+14%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
    {
      title: "Draft",
      value: "34",
      icon: DraftIcon,
      bg: "#8CB369",
      iconColor: "#65A30D",
      trend: null,
      trendType: "neutral",
      subtitle: "In progress",
    },
    {
      title: "Under Review",
      value: "18",
      icon: UnderReviewIcon,
      bg: "#FEB91E",
      iconColor: "#F59E0B",
      trend: null,
      trendType: "neutral",
      subtitle: "In review",
    },
    {
      title: "Paused",
      value: "6",
      icon: PausedIcon,
      bg: "#FC6C4F",
      iconColor: "#F43F5E",
      trend: "-9%",
      trendType: "down",
      subtitle: "vs last 30 days",
    },
    {
      title: "Expired",
      value: "46",
      icon: ExpiredIcon,
      bg: "#696969",
      iconColor: "#FFFFFF",
      trend: "-9%",
      trendType: "down",
      subtitle: "vs last 30 days",
    },
    {
      title: "Disabled",
      value: "12",
      icon: DisabledIcon,
      bg: "#A80101",
      iconColor: "#FFFFFF",
      trend: "+1%",
      trendType: "up",
      subtitle: "vs last 30 days",
    },
  ];

  // table
  const voucherTabs = [
    { key: "all", label: "All Promo Codes", count: 256 },
    { key: "active", label: "Active", count: 148 },
    { key: "scheduled", label: "Scheduled", count: 28 },
    { key: "draft", label: "Draft", count: 34 },
    { key: "underReview", label: "Under Review", count: 18 },
    { key: "paused", label: "Paused", count: 6 },
    { key: "expired", label: "Expired", count: 46 },
    { key: "disabled", label: "Disabled", count: 12 },
  ];

  const statusStyles = {
    Active: { bg: "#E6F7F4", color: "#14B8A6" },
    Scheduled: { bg: "#F3E8FF", color: "#A855F7" },
    Draft: { bg: "#EFFCE9", color: "#65A30D" },
  };

  const vouchersData = [
    {
      id: "PRM-001",
      name: "Welcome 20% Off",
      code: "Welcome 20%",
      type: "Percentage",
      discount: "20% OFF",
      assignedTo: "All Customers",
      redemptionUsed: 1245,
      redemptionLimit: 5000, // ضع null لو Unlimited
      validity: "Mar 10 - May 31, 2025",
      status: "Active",
      lastUpdate: "2h ago",
      updatedBy: "Mona Ali",
    },
    {
      id: "PRM-002",
      name: "Ramadan Special 25%",
      code: "RAMADAN25",
      type: "Percentage",
      discount: "25% OFF",
      assignedTo: "VIP Customers",
      redemptionUsed: 2890,
      redemptionLimit: 10000,
      validity: "Mar 20 - Jun 20, 2025",
      status: "Scheduled",
      lastUpdate: "2h ago",
      updatedBy: "Mona Ali",
    },
    {
      id: "PRM-003",
      name: "Free Shipping",
      code: "FREESHIP",
      type: "Fixed amount",
      discount: "Free Shipping",
      assignedTo: "All Customers",
      redemptionUsed: 856,
      redemptionLimit: null,
      validity: "Mar 01 - May 31, 2025",
      status: "Active",
      lastUpdate: "3h ago",
      updatedBy: "Mona Ali",
    },
    {
      id: "PRM-004",
      name: "New User 15% Off",
      code: "NEWUSER15",
      type: "Percentage",
      discount: "15% OFF",
      assignedTo: "New Customers",
      redemptionUsed: 562,
      redemptionLimit: 2000,
      validity: "-",
      status: "Draft",
      lastUpdate: "1d ago",
      updatedBy: "Mona Ali",
    },
  ];

  const [activeVoucherTab, setActiveVoucherTab] = useState("all");
  const [selectedRows, setSelectedRows] = useState(new Set());
  const [voucherPage, setVoucherPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const totalVouchersCount = 256;

  const filteredVouchers =
    activeVoucherTab === "all"
      ? vouchersData
      : vouchersData.filter(
          (v) => v.status.toLowerCase() === activeVoucherTab.toLowerCase(),
        );

  const totalPages = Math.max(1, Math.ceil(totalVouchersCount / perPage));

  const startIndex = (voucherPage - 1) * perPage;

  const currentPageData = filteredVouchers.slice(
    startIndex,
    startIndex + perPage,
  );

  const allSelected =
    currentPageData.length > 0 &&
    currentPageData.every((v) => selectedRows.has(v.id));

  const toggleRow = (id) => {
    setSelectedRows((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });
  };

  const toggleSelectAll = () => {
    setSelectedRows((prev) => {
      const next = new Set(prev);
      if (allSelected) {
        currentPageData.forEach((v) => next.delete(v.id));
      } else {
        currentPageData.forEach((v) => next.add(v.id));
      }
      return next;
    });
  };

  const getPageNumbers = (current, total) => {
    const pages = [];
    if (total <= 5) {
      for (let i = 1; i <= total; i++) pages.push(i);
      return pages;
    }
    pages.push(1, 2, 3, "...", total);
    return pages;
  };

  const pageNumbers = getPageNumbers(voucherPage, totalPages);
  const activeTabLabel =
    voucherTabs.find((t) => t.key === activeVoucherTab)?.label ||
    "All Vouchers";

  const usageTrendData = [
    { name: "Apr 22", redemption: 3400 },
    { name: "Apr 25", redemption: 5800 },
    { name: "Apr 29", redemption: 11200 },
    { name: "May 02", redemption: 6800 },
    { name: "May 06", redemption: 4600 },
    { name: "May 09", redemption: 5200 },
    { name: "May 11", redemption: 4300 },
    { name: "May 13", redemption: 6000 },
    { name: "May 16", redemption: 3000 },
    { name: "May 18", redemption: 3600 },
    { name: "May 20", redemption: 2500 },
  ];

  // Business Impact Overview
  const businessImpact = [
    {
      title: "Total Redemptions",
      value: "18,520",
      icon: Users,
      trend: "+15%",
      color: "#111827",
    },
    {
      title: "Redeemed",
      value: "17,930",
      icon: Check,
      trend: "+18%",
      color: "#14B8A6",
    },
    {
      title: "Failed Attempts",
      value: "590",
      icon: X,
      trend: "+18%",
      color: "#DC2626",
    },
    {
      title: "Unique Users",
      value: "9,420",
      icon: Users,
      trend: "+8%",
      color: "#7C3AED",
    },
  ];

  // Voucher Health (donut)
  const voucherHealthData = [
    { label: "Active", count: 148, pct: 57.8, color: "#3FBEAC" },
    { label: "Scheduled", count: 34, pct: 10.9, color: "#7E1BAD" },
    { label: "Draft", count: 41, pct: 13.3, color: "#8CB369" },
    { label: "Under Review", count: 22, pct: 7.0, color: "#FEB91E" },
    { label: "Paused", count: 7, pct: 2.3, color: "#FC6C4F" },
    { label: "Expired", count: 19, pct: 6.2, color: "#696969" },
    { label: "Disabled", count: 15, pct: 4.7, color: "#A80101" },
  ];

  const voucherHealthTotal = 312;

  // Build conic-gradient stops from the donut data
  const buildConicGradient = (segments) => {
    let acc = 0;
    const stops = segments.map((s) => {
      const start = acc;
      acc += s.pct;
      return `${s.color} ${start}% ${acc}%`;
    });
    return `conic-gradient(${stops.join(", ")})`;
  };

  // Distribution Channels
  const distributionChannels = [
    { num: "1", label: "WELCOME20", pct: 89 },
    { num: "2", label: "Summer25", pct: 70 },
    { num: "3", label: "VIP30", pct: 55 },
    { num: "4", label: "FREESHIP", pct: 30 },
  ];

  // Top User Segements
  const topUserSegements = [
    { num: "1", label: "New Customers", pct: 42 },
    { num: "2", label: "VIP Customers", pct: 28 },
    { num: "3", label: "Existing Customers", pct: 18 },
    { num: "4", label: "Infrequent Users", pct: 12 },
  ];

    // Near Expiry Vouchers
  const abuseDetection = [
    {
      image: Abuse1,
      name: "Multiple failed attempts",
      days: "145",
    },
    {
      image: Abuse2,
      name: "High filed redemption rate",
      days: "98",
    },
    {
      image: Abuse3,
      name: " Repeated by same device",
      days: "76",
    },
    {
      image: Abuse4,
      name: "Exceeded daily attempts",
      days: "54",
    },
  ];

  // Most Used Promo Codes
  const mostUsedPromoCodes = [
    {
      icon: Gift,
      color: "#3FBEAC",
      bgColor: "#FEF3E8",
      name: "WELCOME20",
      value: "4,000 EGP",
      percent: "30%",
    },
    {
      icon: Sun,
      color: "#FACC15",
      bgColor: "#FEFCE8",
      name: "SUMMER25",
      value: "3,800 EGP",
      percent: "23%",
    },
    {
      icon: Moon,
      color: "#FEB91E",
      bgColor: "#FEF6E5",
      name: "RAMADAN50",
      value: "2,090 EGP",
      percent: "13%",
    },
    {
      icon: Truck,
      color: "#000000",
      bgColor: "#ffffff",
      name: "FREESHIP",
      value: "1,500 EGP",
      percent: "14%",
    },
  ];

  // Least Used Promo Codes
  const leastUsedPromoCodes = [
    {
      icon: newYear,
      bgColor: "#FEF3E8",
      name: "NEWYEAR50",
      value: "3",
      percent: "0.1%",
    },
    {
      icon: welcome,
      bgColor: "#FEFCE8",
      name: "WELCOME2026",
      value: "7",
      percent: "0.2%",
    },
    {
      icon: special,
      bgColor: "#FEF6E5",
      name: "SPECIAL100",
      value: "9",
      percent: "0.3%",
    },
    {
      icon: blackFriday,
      bgColor: "#ffffff",
      name: "BLACKFRIDAY30",
      value: "12",
      percent: "0.4%",
    },
  ];

  // Recent Activity
  const recentActivity = [
    {
      name: "Osama Ali",
      avatar: OsamaAvatar,
      action: "created promo code",
      target: "WELCOME20",
      time: "20m ago",
    },
    {
      name: "Ahmed Hassan",
      avatar: AhmedAvatar,
      action: "updated promo code",
      target: "RAMDAN50",
      time: "1h ago",
    },
    {
      name: "Ahmed Hassan",
      avatar: AhmedAvatar,
      action: "disabled promo code",
      target: "FLASHSALE",
      time: "1h ago",
    },
    {
      name: "Mona Salah",
      avatar: MonaAvatar,
      action: "scheduled promo code",
      target: "FREESHIP",
      time: "2h ago",
    },
  ];

  // Near Expiry Vouchers
  const nearExpiryVouchers = [
    {
      image: WELCOME2026,
      name: "WELCOME2026",
      days: "Expires in 2 days",
    },
    {
      image: SUMMER25,
      name: "SUMMER25",
      days: "Expires in 5 days",
    },
    {
      image: FALSH50,
      name: "FALSH50",
      days: "Expires in 7 days",
    },
    {
      image: VIP30,
      name: "VIP30",
      days: "Expires in 10 days",
    },
  ];

  return (
    <div className="voucher-page-wrapper">
      <div className="voucher-overview">
        {/* HEADER */}
        <div className="voucher-header">
          <div className="voucher-header-left">
            <h3>Promo Codes</h3>
            <p>
              Manage, monitor and analyze all voucher campaigns across the
              platform.
            </p>
          </div>
          <div className="header-right">
            <button className="incentive-btn create">
              <i className="fa-solid fa-plus"></i>
              Create Promo Code
            </button>

            <button className="incentive-btn light">
              <i className="fa-solid fa-download"></i>
              Export
            </button>
          </div>
        </div>
        {/* STATS */}
        <div className="vouchers-stats-grid">
          {stats.map((item, i) => (
            <div className="vouchers-stat-card" key={i}>
              <div className="vouchers-stat-top">
                <div
                  className="vouchers-stat-icon"
                  style={{ backgroundColor: item.bg }}
                >
                  <img
                    src={item.icon}
                    alt={item.title}
                    className="vouchers-stat-icon-img"
                  />
                </div>
                <span className="vouchers-stat-title">{item.title}</span>
              </div>

              <div className="vouchers-stat-value">{item.value}</div>

              <div className="vouchers-stat-bottom">
                {item.trend ? (
                  <>
                    <span
                      className={`vouchers-trend vouchers-trend-${item.trendType}`}
                    >
                      {item.trend}
                    </span>
                    <span className="vouchers-trend-text">{item.subtitle}</span>
                  </>
                ) : (
                  <span className="vouchers-trend-text">{item.subtitle}</span>
                )}
              </div>
            </div>
          ))}
        </div>
        {/* FILTERS */}
        <div className="vouchers-filters-bar">
          <div className="vouchers-search-box">
            <Search size={16} color="#9CA3AF" />
            <input
              type="text"
              className="vouchers-search-input"
              placeholder="Search voucher by name, code, id.."
            />
          </div>

          <div className="vouchers-filters-right">
            <div className="vouchers-filter-group">
              <label className="vouchers-filter-label">Type</label>
              <select className="vouchers-filter-select" defaultValue="all">
                <option value="all">All Types</option>
                <option value="fixed">Fixed</option>
                <option value="percentage">Percentage</option>
              </select>
            </div>

            <div className="vouchers-filter-group">
              <label className="vouchers-filter-label">Funding Source</label>
              <select className="vouchers-filter-select" defaultValue="all">
                <option value="all">All Sources</option>
                <option value="internal">Internal</option>
                <option value="partner">Partner</option>
              </select>
            </div>

            <div className="vouchers-filter-group">
              <label className="vouchers-filter-label">
                Distribution Channel
              </label>
              <select className="vouchers-filter-select" defaultValue="all">
                <option value="all">All Channels</option>
                <option value="app">App</option>
                <option value="web">Web</option>
              </select>
            </div>

            <div className="vouchers-filter-group">
              <label className="vouchers-filter-label">Date Range</label>
              <button
                type="button"
                className="vouchers-date-range-btn"
                onClick={handleDateClick}
              >
                <span>{dateRangeLabel}</span>
                <Calendar size={16} color="#6B7280" />
              </button>

              <Popover
                open={isDatePickerOpen}
                anchorEl={dateAnchorEl}
                onClose={handleDateClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <Box sx={{ p: 2, display: "flex", gap: 2 }}>
                    <DatePicker
                      label="From"
                      value={startDate}
                      onChange={(newValue) =>
                        newValue && setStartDate(newValue)
                      }
                      maxDate={endDate}
                      slotProps={{ textField: { size: "small" } }}
                    />
                    <DatePicker
                      label="To"
                      value={endDate}
                      onChange={(newValue) => newValue && setEndDate(newValue)}
                      minDate={startDate}
                      slotProps={{ textField: { size: "small" } }}
                    />
                  </Box>
                </LocalizationProvider>
              </Popover>
            </div>
          </div>
        </div>
        {/* VOUCHERS TABLE */}
        <div className="vouchers-table-section">
          <div className="vouchers-tabs-bar">
            {voucherTabs.map((tab) => (
              <button
                key={tab.key}
                className={`vouchers-tab ${
                  activeVoucherTab === tab.key ? "active" : ""
                }`}
                onClick={() => {
                  setActiveVoucherTab(tab.key);
                  setVoucherPage(1);
                  setSelectedRows(new Set());
                }}
              >
                {tab.label}{" "}
                <span className="vouchers-tab-count">{tab.count}</span>
              </button>
            ))}
          </div>
          <div className="vouchers-table-card">
            <div className="vouchers-table-header">
              <h3>{activeTabLabel}</h3>
              {selectedRows.size > 0 && (
                <div className="vouchers-bulk-actions">
                  <span className="vouchers-selected-count">
                    {selectedRows.size} selected
                  </span>
                  <span className="vouchers-bulk-divider">|</span>
                  <span className="vouchers-bulk-label">Bulk actions:</span>
                  <button className="vouchers-bulk-btn vouchers-bulk-activate">
                    <Check size={14} /> Activate
                  </button>
                  <button className="vouchers-bulk-btn vouchers-bulk-pause">
                    <Pause size={14} /> Pause
                  </button>
                  <button className="vouchers-bulk-btn vouchers-bulk-delete">
                    <Trash2 size={14} /> Delete
                  </button>
                  <button
                    className="vouchers-clear-selection"
                    onClick={() => setSelectedRows(new Set())}
                  >
                    <X size={14} /> Clear Selection
                  </button>
                </div>
              )}
            </div>
            <div className="vouchers-table-wrapper">
              <table className="vouchers-data-table">
                <thead>
                  <tr>
                    <th className="vouchers-checkbox-cell">
                      <input
                        type="checkbox"
                        checked={allSelected}
                        onChange={toggleSelectAll}
                      />
                    </th>
                    <th>ID</th>
                    <th>Code</th>
                    <th>Promo Name</th>
                    <th>Type</th>
                    <th>Discount</th>
                    <th>Usage Used/Limit</th>
                    <th>Status</th>
                    <th>Validity</th>
                    <th>Assigned To</th>
                    <th>Last Update</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {currentPageData.map((v) => {
                    const percent = v.redemptionLimit
                      ? Math.round((v.redemptionUsed / v.redemptionLimit) * 100)
                      : 0;
                    const barColor = percent > 80 ? "red" : "green";
                    const style = statusStyles[v.status] || {
                      bg: "#F3F4F6",
                      color: "#6B7280",
                    };
                    return (
                      <tr key={v.id}>
                        <td className="vouchers-checkbox-cell">
                          <input
                            type="checkbox"
                            checked={selectedRows.has(v.id)}
                            onChange={() => toggleRow(v.id)}
                          />
                        </td>
                        <td className="vouchers-id-cell">{v.id}</td>
                        <td>
                          <span className="vouchers-code-badge">{v.code}</span>
                        </td>
                        <td className="vouchers-name-cell">{v.name}</td>
                        <td>{v.type}</td>
                        <td>{v.discount}</td>
                        <td>
                          <div className="vouchers-remaining-cell">
                            <span>
                              {v.redemptionUsed.toLocaleString()} /{" "}
                              {v.redemptionLimit
                                ? v.redemptionLimit.toLocaleString()
                                : "Unlimited"}
                            </span>
                            {v.redemptionLimit && (
                              <div className="vouchers-remaining-bar-bg">
                                <div
                                  className={`vouchers-remaining-bar-fill vouchers-bar-${barColor}`}
                                  style={{ width: `${percent}%` }}
                                />
                              </div>
                            )}
                          </div>
                        </td>
                        <td>
                          <span
                            className="vouchers-status-badge"
                            style={{
                              backgroundColor: style.bg,
                              color: style.color,
                            }}
                          >
                            <span
                              className="vouchers-status-dot"
                              style={{ backgroundColor: style.color }}
                            />
                            {v.status}
                            <Info size={12} />
                          </span>
                        </td>
                        <td>{v.validity}</td>
                        <td>{v.assignedTo}</td>
                        <td className="vouchers-lastupdate-cell">
                          <div>{v.lastUpdate}</div>
                          <div className="vouchers-lastupdate-user">
                            {v.updatedBy}
                          </div>
                        </td>
                        <td className="vouchers-action-cell">
                          <FiMoreVertical
                            onClick={() => navigate(`/vouchers/${v.id}`)}
                            size={16}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="vouchers-table-footer">
              <span className="vouchers-showing-text">
                Showing {startIndex + 1} of{" "}
                {Math.min(startIndex + perPage, totalVouchersCount)} of{" "}
                {totalVouchersCount} promo codes
              </span>
              <div className="vouchers-footer-right">
                <select
                  className="vouchers-perpage-select"
                  value={perPage}
                  onChange={(e) => {
                    setPerPage(Number(e.target.value));
                    setVoucherPage(1);
                  }}
                >
                  <option value={10}>10 per page</option>
                  <option value={25}>25 per page</option>
                  <option value={50}>50 per page</option>
                </select>
                <div className="vouchers-pagination">
                  <button
                    className="vouchers-page-arrow"
                    disabled={voucherPage === 1}
                    onClick={() => setVoucherPage((p) => Math.max(1, p - 1))}
                  >
                    <ChevronLeft size={16} />
                  </button>

                  {pageNumbers.map((n, i) =>
                    n === "..." ? (
                      <span key={i} className="vouchers-page-ellipsis">
                        ...
                      </span>
                    ) : (
                      <button
                        key={i}
                        className={`vouchers-page-btn ${
                          voucherPage === n ? "active" : ""
                        }`}
                        onClick={() => setVoucherPage(n)}
                      >
                        {n}
                      </button>
                    ),
                  )}

                  <button
                    className="vouchers-page-arrow"
                    disabled={voucherPage === totalPages}
                    onClick={() =>
                      setVoucherPage((p) => Math.min(totalPages, p + 1))
                    }
                  >
                    <ChevronRight size={16} />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* INSIGHTS SECTION */}
        <div className="voucher-insights-section">
          {/* LEFT COLUMN */}
          <div className="voucher-insights-left">
            {/* Business Impact Overview */}
            <div className="vi-card">
              <h4 className="vi-card-title">Business Impact Overview</h4>
              <div className="business-impact-grid">
                {businessImpact.map((item, i) => (
                  <div className="bi-item" key={i}>
                    <div
                      className="bi-icon-circle"
                      style={{ backgroundColor: item.color }}
                    >
                      <item.icon size={16} color="#fff" />
                    </div>
                    <div className="bi-content">
                      <span className="bi-label">{item.title}</span>
                      <div className="bi-value">{item.value}</div>
                      <div className="bi-trend">
                        <span className="bi-trend-arrow">
                          <ArrowUpRight size={10} />
                        </span>
                        <span className="bi-trend-pct">{item.trend}</span>
                        <span className="bi-trend-text">vs last 30 days</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Usage Trend */}
            <div className="vi-card">
              <div className="vi-card-header">
                <h4 className="vi-card-title">
                  Usage Trend{" "}
                  <span className="vi-card-title-sub">(Last 30 Days)</span>{" "}
                </h4>
                <button className="vi-period-select">
                  Last 30 Days <FiChevronDown size={14} />
                </button>
              </div>
              <div className="usage-trend-chart">
                <ResponsiveContainer width="100%" height={345}>
                  <ComposedChart
                    data={usageTrendData}
                    margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
                  >
                    <CartesianGrid
                      horizontal={true}
                      vertical={false}
                      strokeDasharray="4 4"
                      stroke="#E5E7EB"
                    />
                    <XAxis
                      dataKey="name"
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: 12, fill: "#9CA3AF" }}
                      interval="preserveStartEnd"
                      ticks={["Apr 22", "Apr 29", "May 06", "May 13", "May 20"]}
                      padding={{ left: 10, right: 10 }}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      tick={{ fontSize: 12, fill: "#9CA3AF" }}
                      tickFormatter={(v) => (v === 0 ? "0" : `${v / 1000}k`)}
                      domain={[0, 12000]}
                      ticks={[0, 2000, 4000, 6000, 8000, 10000, 12000]}
                    />
                    <Tooltip />
                    <defs>
                      <linearGradient
                        id="usageTrendGradient"
                        x1="0"
                        y1="0"
                        x2="0"
                        y2="1"
                      >
                        <stop
                          offset="0%"
                          stopColor="#3FBEAC"
                          stopOpacity={0.25}
                        />
                        <stop
                          offset="100%"
                          stopColor="#3FBEAC"
                          stopOpacity={0}
                        />
                      </linearGradient>
                    </defs>
                    <Area
                      type="natural"
                      dataKey="redemption"
                      stroke="#3FBEAC"
                      strokeWidth={3}
                      fill="url(#usageTrendGradient)"
                      dot={false}
                      activeDot={{
                        r: 4,
                        fill: "#3FBEAC",
                        stroke: "#fff",
                        strokeWidth: 2,
                      }}
                    />
                  </ComposedChart>
                </ResponsiveContainer>
              </div>
            </div>
            {/* Promo Codes Health + Near Usage Limit */}
            <div className="vi-two-col-row">
              {/* Promo Codes Health */}
              <div className="vi-card vi-half-card">
                <h4 className="vi-card-title">Promo Codes Health</h4>
                <div className="voucher-health-body">
                  <div className="donut-wrapper">
                    <div
                      className="donut-ring"
                      style={{
                        background: buildConicGradient(voucherHealthData),
                      }}
                    >
                      <div className="donut-hole">
                        <span className="donut-total">
                          {voucherHealthTotal}
                        </span>
                        <span className="donut-total-label">Total</span>
                      </div>
                    </div>
                  </div>
                  <div className="donut-legend">
                    {voucherHealthData.map((s, i) => (
                      <div className="donut-legend-row" key={i}>
                        <span
                          className="donut-legend-dot"
                          style={{ backgroundColor: s.color }}
                        />
                        <span className="donut-legend-label">
                          {s.label} ({s.count})
                        </span>
                        <span className="donut-legend-pct">{s.pct}%</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* Near Usage Limit */}
              <div className="vi-card vi-half-card">
                <h4 className="vi-card-title">Near Usage Limit</h4>
                <div className="dist-list">
                  {distributionChannels.map((c, i) => (
                    <div className="dist-row" key={i}>
                      <div className="dist-left">
                        <span className="dist-num-circle">{c.num}</span>
                        <span className="dist-label">{c.label}</span>
                      </div>
                      <div className="dist-bar-bg">
                        <div
                          className="promo-dist-bar-fill"
                          style={{ width: `${c.pct}%` }}
                        />
                      </div>
                      <span className="dist-pct">{c.pct.toFixed(1)}%</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            {/* Top User Segements + Abuse Detection */}
            <div className="vi-two-col-row">
              {/* Top User Segements */}
              <div className="vi-card vi-half-card">
                <h4 className="vi-card-title">Top User Segements</h4>
                <div className="dist-list">
                  {topUserSegements.map((c, i) => (
                    <div className="dist-row" key={i}>
                      <div className="dist-left">
                        <span className="seg-dist-num-circle">{c.num}</span>
                        <span className="dist-label">{c.label}</span>
                      </div>
                      <div className="dist-bar-bg">
                        <div
                          className="seg-dist-bar-fill"
                          style={{ width: `${c.pct}%` }}
                        />
                      </div>
                      <span className="dist-pct">{c.pct.toFixed(1)}%</span>
                    </div>
                  ))}
                </div>
              </div>
              {/* Abuse Detection */}
              <div className="vi-card vi-half-card">
                <div className="vi-card-header">
                  <h4 className="vi-card-title">Abuse Detection</h4>
                  <span className="vi-view-all">
                    View all <ArrowRight size={14} />
                  </span>
                </div>
                <div className="sidebar-list">
                  {abuseDetection.map((v, i) => (
                    <div className="sidebar-row" key={i}>
                      <div className="sidebar-left">
                        <div className="abuse">
                          <img
                            src={v.image}
                            alt={v.name}
                            className="abuse-sidebar-icon-image"
                          />
                        </div>
                        <span className="sidebar-name">{v.name}</span>
                      </div>
                      <span className="abuse-sidebar-days">{v.days}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          {/* RIGHT COLUMN (SIDEBAR) */}
          <div className="voucher-insights-right">
            {/* Most Used Promo Codes */}
            <div className="vi-card">
              <div className="vi-card-header">
                <h4 className="vi-card-title">Most Used Promo Codes</h4>
                <span className="vi-view-all">
                  View all <ArrowRight size={14} />
                </span>
              </div>
              <div className="sidebar-list">
                {mostUsedPromoCodes.map((v, i) => (
                  <div className="sidebar-row" key={i}>
                    <div className="sidebar-left w-50">
                      <div
                        className="sidebar-icon-circle"
                        style={{ backgroundColor: v.bgColor }}
                      >
                        <v.icon size={14} color={v.color} />
                      </div>
                      <span className="sidebar-name">{v.name}</span>
                    </div>
                    <span className="sidebar-value">{v.value}</span>

                    <div className="sidebar-right">
                      <span className="sidebar-percent small">{v.percent}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Least Used Promo Codes */}
            <div className="vi-card">
              <div className="vi-card-header">
                <h4 className="vi-card-title">Least Used Promo Codes</h4>
                <span className="vi-view-all">
                  View all <ArrowRight size={14} />
                </span>
              </div>
              <div className="sidebar-list">
                {leastUsedPromoCodes.map((v, i) => (
                  <div className="sidebar-row" key={i}>
                    <div className="sidebar-left w-50">
                      <div
                        className="sidebar-icon-circle"
                        style={{ backgroundColor: v.bgColor }}
                      >
                        <img src={v.icon} alt={v.name} width={14} height={14} />
                      </div>
                      <span className="sidebar-name">{v.name}</span>
                    </div>
                    <span className="sidebar-value">{v.value}</span>

                    <div className="sidebar-right">
                      <span className="sidebar-percent small">{v.percent}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {/* Near Expiry Voucher */}
            <div className="vi-card">
              <div className="vi-card-header">
                <h4 className="vi-card-title">Expiring Soon</h4>
                <span className="vi-view-all">
                  View all <ArrowRight size={14} />
                </span>
              </div>
              <div className="sidebar-list">
                {nearExpiryVouchers.map((v, i) => (
                  <div className="sidebar-row" key={i}>
                    <div className="sidebar-left">
                      <div className="sidebar-icon-circle sidebar-icon-outline">
                        <img
                          src={v.image}
                          alt={v.name}
                          className="sidebar-icon-image"
                        />
                      </div>
                      <span className="sidebar-name">{v.name}</span>
                    </div>
                    <span className="sidebar-days">{v.days}</span>
                  </div>
                ))}
              </div>
            </div>
            {/* Recent Activity */}
            <div className="vi-card">
              <div className="vi-card-header">
                <h4 className="vi-card-title">Recent Activity</h4>
                <span className="vi-view-all">
                  View all <ArrowRight size={14} />
                </span>
              </div>
              <div className="sidebar-list activity-list">
                {recentActivity.map((a, i) => (
                  <div className="sidebar-row activity-row" key={i}>
                    <div className="sidebar-left">
                      <img
                        src={a.avatar}
                        alt={a.name}
                        className="activity-avatar"
                      />
                      <span className="activity-text">
                        <b>{a.name}</b> {a.action} <b>{a.target}</b>
                      </span>
                    </div>
                    <span className="sidebar-time">{a.time}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
